export default [
  {
    path: '/appeal',
    component: () => import('../../views/appeal/appeal.vue'),
    name: 'appeal',
    meta: {
      backgroundClass: 'bg-black',
      title: '申诉',
    },
    hidden: true,
  },
  {
    path: '/appeal-result',
    component: () => import('../../views/appeal/appealResult.vue'),
    name: 'appeal-result',
    meta: {
      backgroundClass: 'bg-black',
      title: '申诉',
    },
    hidden: true,
  },
];
